import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'OrganizationGroups.Description',
    defaultMessage:
      'Content authors can target Groups in various areas in Workgrid on the “Select Your Audience” page. Learn about your available groups below. Make Groups targetable in User Attributes. To edit your Groups, contact your SCIM administrator.'
  },
  groupName: {
    id: 'OrganizationGroups.GroupName',
    defaultMessage: 'Group Name'
  },
  noGroups: {
    id: 'OrganizationGroups.NoGroups',
    defaultMessage: 'There are no groups in this organization'
  },
  userAttributes: {
    id: 'OrganizationUserAttributes.Title',
    defaultMessage: 'User Attributes'
  },
  userCount: {
    id: 'OrganizationGroups.UserCount',
    defaultMessage: 'User Count'
  },
  userList: {
    id: 'OrganizationGroups.UserList',
    defaultMessage: 'User List'
  }
})
